function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function t(t, e, r) {
  return e = o(e), function (t, e) {
    if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(t);
  }(t, i() ? Reflect.construct(e, r || [], o(t).constructor) : e.apply(t, r));
}
function e(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function r(t, e, r) {
  return Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function n(t, e, r) {
  return (e = function (t) {
    var e = function (t, e) {
      if ("object" != _typeof(t) || !t) return t;
      var r = t[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(t, e || "default");
        if ("object" != _typeof(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === e ? String : Number)(t);
    }(t, "string");
    return "symbol" == _typeof(e) ? e : e + "";
  }(e)) in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function o(t) {
  return o = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, o(t);
}
function u(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && a(t, e);
}
function i() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (i = function i() {
    return !!t;
  })();
}
function c(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function f(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = null != arguments[e] ? arguments[e] : {};
    e % 2 ? c(Object(r), !0).forEach(function (e) {
      n(t, e, r[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : c(Object(r)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
    });
  }
  return t;
}
function p(t, e) {
  if (null == t) return {};
  var r,
    n,
    o = function (t, e) {
      if (null == t) return {};
      var r = {};
      for (var n in t) if ({}.hasOwnProperty.call(t, n)) {
        if (e.includes(n)) continue;
        r[n] = t[n];
      }
      return r;
    }(t, e);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(t);
    for (n = 0; n < u.length; n++) r = u[n], e.includes(r) || {}.propertyIsEnumerable.call(t, r) && (o[r] = t[r]);
  }
  return o;
}
function a(t, e) {
  return a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, a(t, e);
}
function l(t) {
  return l = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
    return _typeof(t);
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
  }, l(t);
}
function y(t) {
  var e = "function" == typeof Map ? new Map() : void 0;
  return y = function y(t) {
    if (null === t || !function (t) {
      try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
      } catch (e) {
        return "function" == typeof t;
      }
    }(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== e) {
      if (e.has(t)) return e.get(t);
      e.set(t, r);
    }
    function r() {
      return function (t, e, r) {
        if (i()) return Reflect.construct.apply(null, arguments);
        var n = [null];
        n.push.apply(n, e);
        var o = new (t.bind.apply(t, n))();
        return r && a(o, r.prototype), o;
      }(t, arguments, o(this).constructor);
    }
    return r.prototype = Object.create(t.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), a(r, t);
  }, y(t);
}
export { l as _, r as a, e as b, f as c, p as d, u as e, y as f, t as g };